import React from 'react';

import { PrimaryButton } from '@components/Button/variants';

import Testimonial, { TestimonialProps } from './Testimonial';

const TESTIMONIAL_DATA: TestimonialProps[] = [
  {
    name: 'Jeff Weiner',
    title: 'Executive Chairman, LinkedIn',
    quote:
      'Just subscribed to The Information. Rationale was simple: repeatedly saw excerpts of relevant, exclusive material valuable enough to pay for.”',
  },
  {
    name: 'World Economic Forum',
    quote:
      'The Information is akin to the B2B publication, or specialized industry newsletter, reinvented for the digital age.”',
  },
];

const CTAAndTestimonials = () => {
  return (
    <aside
      data-test="cta-and-testimonials"
      className="mt-48 border-0 border-t border-solid border-grayscale-beige px-16 pt-48 sm:mx-28 sm:px-0 xl:mx-[200px] xl:mt-64 xl:pt-64"
    >
      <h2 className="mx-auto my-0 max-w-[800px] text-center font-suisse-neue text-subheadline-md font-medium">
        Leading companies use The Information group subscriptions to make sure their employees are
        always the smartest people in the room.
      </h2>
      <PrimaryButton as="link" href="#IntroAndForm" className="anchor-link mx-auto mt-32 sm:mt-48">
        Connect with our team
      </PrimaryButton>
      <article className="mt-48 flex flex-col items-center justify-center gap-48 sm:flex-row sm:items-stretch md:gap-[54px] xl:mt-64 xl:gap-[154px]">
        {TESTIMONIAL_DATA.map((testimonial) => (
          <Testimonial
            key={testimonial.name}
            name={testimonial.name}
            quote={testimonial.quote}
            title={testimonial.title}
          />
        ))}
      </article>
    </aside>
  );
};

export default CTAAndTestimonials;
